import { render, staticRenderFns } from "./data-processing-page.vue?vue&type=template&id=081c7f4b&scoped=true"
import script from "./data-processing-page.vue?vue&type=script&lang=js"
export * from "./data-processing-page.vue?vue&type=script&lang=js"
import style0 from "./data-processing-page.vue?vue&type=style&index=0&id=081c7f4b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081c7f4b",
  null
  
)

export default component.exports